import Command from "@ckeditor/ckeditor5-core/src/command"

export default class InsertNextPageBox extends Command {
  execute() {
    this.editor.model.change((writer) => {
      this.editor.model.insertContent(this.createNextPageBox(writer))
    })
  }

  refresh() {
    const model = this.editor.model
    const selection = model.document.selection
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "nextPageBox"
    )

    this.isEnabled = allowedIn !== null
  }

  createNextPageBox(writer) {
    const box = writer.createElement("nextPageBox")
    const label = writer.createElement("nextPageBoxLabel")
    const nextPage = writer.createElement("nextPageBoxTitle")
    writer.append(label, box)
    writer.appendText("改ページ", label)
    writer.append(nextPage, box)
    return box
  }
}
